var map = {
	"./apple/apple-touch-icon-152x152.png": 12294,
	"./apple/apple-touch-icon-57x57.png": 52538,
	"./apple/apple-touch-startup-image-320x460.png": 35423,
	"./apple/apple-touch-startup-image-640x1096.png": 1314,
	"./body-bg.jpg": 37135,
	"./favicon-128.png": 45992,
	"./favicon/favicon-16x16.png": 7304,
	"./favicon/favicon-32x32.png": 7460,
	"./favicon/favicon-96.png": 77261,
	"./favicon/favicon-96x96.png": 99176,
	"./favicon/favicon.ico": 87443,
	"./logo.png": 28790,
	"./logo_header_long.png": 23059,
	"./logo_header_long_dark.png": 99268,
	"./wdsf-icon.png": 61739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52819;